/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Faq_Q3Inputs */

const en_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can multiple people use my invite code?`)
};

const ar_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل يمكن لعدة أشخاص استخدام رمز الدعوة الخاص بي؟`)
};

const de_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Können mehrere Personen meinen Einladungscode verwenden?`)
};

const es_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Varias personas pueden usar mi código de invitación?`)
};

const fr_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusieurs personnes peuvent-elles utiliser mon code d’invitation ?`)
};

const it_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più persone possono usare il mio codice invito?`)
};

const ja_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数の人が私の招待コードを使えますか？`)
};

const ko_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여러 사람이 내 초대 코드를 사용할 수 있나요?`)
};

const pt_br_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Várias pessoas podem usar meu código de convite?`)
};

const ru_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Могут ли несколько человек использовать мой код приглашения?`)
};

const th_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หลายคนสามารถใช้รหัสเชิญของฉันได้ไหม?`)
};

const tr_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodumu birden fazla kişi kullanabilir mi?`)
};

const zh_cn_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的邀请码可以给多人使用吗？`)
};

const zh_tw_invite_page_faq_q3 = /** @type {(inputs: Invite_Page_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的邀請碼可以給多人使用嗎？`)
};

/**
* | output |
* | --- |
* | "Can multiple people use my invite code?" |
*
* @param {Invite_Page_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_faq_q3 = /** @type {((inputs?: Invite_Page_Faq_Q3Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Faq_Q3Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_faq_q3(inputs)
	if (locale === "ar") return ar_invite_page_faq_q3(inputs)
	if (locale === "de") return de_invite_page_faq_q3(inputs)
	if (locale === "es") return es_invite_page_faq_q3(inputs)
	if (locale === "fr") return fr_invite_page_faq_q3(inputs)
	if (locale === "it") return it_invite_page_faq_q3(inputs)
	if (locale === "ja") return ja_invite_page_faq_q3(inputs)
	if (locale === "ko") return ko_invite_page_faq_q3(inputs)
	if (locale === "pt_br") return pt_br_invite_page_faq_q3(inputs)
	if (locale === "ru") return ru_invite_page_faq_q3(inputs)
	if (locale === "th") return th_invite_page_faq_q3(inputs)
	if (locale === "tr") return tr_invite_page_faq_q3(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_faq_q3(inputs)
	return zh_tw_invite_page_faq_q3(inputs)
});